var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lighthouse-report',{attrs:{"id":_vm.id,"apiEndpoint":_vm.apiEndpoint,"displayUrl":_vm.displayUrl,"report":_vm.report}})}
var staticRenderFns = []

export { render, staticRenderFns }